"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaults = void 0;
exports.defaults = {
    api: {
        gateway: {
            port: 8000,
        },
        auth: {
            port: 3001,
        },
        editorialDesk: {
            port: 3002,
        },
        mdlinxMain: {
            port: 3003,
        },
    },
};
//# sourceMappingURL=defaults.js.map